<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on: dialogo }">
      <v-list-item v-on="dialogo" @click.stop="dialog = true">
        <v-list-item-title class="red--text">Eliminar</v-list-item-title>
      </v-list-item>
    </template>
    <!-- Modal -->
    <v-card>
      <!-- Título -->
      <v-card-title>
        ¿Estás seguro de que deseas eliminar esta mesa?
      </v-card-title>
      <!-- Acciones posibles -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- Botón que cancela la operación -->
        <v-btn :color="mainColor" text @click="dialog = false">Cancelar</v-btn>
        <!-- Detonador para eliminar la venta -->
        <v-btn class="red--text" text @click="deleteTable">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// importar servicios
import TablesServices from "@/services/TablesServices";

export default {
  props: {
    tableId: {
      type: String
    }
  },
  data() {
    return {
      mainColor: "#1DDF96",
      dialog: false
    };
  },
  methods: {
    deleteTable: async function() {
      // Generamos peticion
      try {
        // Constante para almacenar lo que regrese la petición
        await TablesServices.deleteTable(this.tableId);

        // Se cierra el dialogo si todo sale éxitoso
        this.dialog = false;

        // Emitir mensaje
        this.$emit("table-deleted");
      } catch (err) {
        // Emitir el error
        this.$emit("table-error", err.message);
      }
    }
  }
};
</script>
